"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeLeft = getTimeLeft;
exports.Countdowns = void 0;

var _constants = require("./constants");

var _validation = require("./lib/validation");

var _id = require("./lib/id");

var _getMs = require("./lib/get-ms");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_COUNTDOWN_CONFIG = {
  interval: _constants.Interval.SECONDS
};

function validateCountdownConfig(countdownConfig) {
  if (!countdownConfig) {
    throw new Error("You must pass a valid countdown configuration object");
  }

  (0, _validation.validateInterval)(countdownConfig.interval);

  if (!Number.isInteger(countdownConfig.until)) {
    throw new Error("until must be an integer");
  }
}

function convert(difference, interval) {
  var intervalValue = _constants.IntervalMap[interval];
  var result = difference / 1000;

  if (intervalValue >= _constants.IntervalMap[_constants.Interval.MINUTES]) {
    result /= 60;
  }

  if (intervalValue >= _constants.IntervalMap[_constants.Interval.HOURS]) {
    result /= 60;
  }

  if (intervalValue >= _constants.IntervalMap[_constants.Interval.DAYS]) {
    result /= 24;
  }

  return result;
}

function calculateTimeLeft(config) {
  // until is timestamp in milliseconds that should be reached
  var difference = config.until - Date.now(); // Convert the difference to the specified interval

  var timeLeft = Math.ceil(convert(difference, config.interval));
  return timeLeft > 0 ? timeLeft : 0;
}

function getTimeLeft(countdownConfig) {
  validateCountdownConfig(countdownConfig);

  var config = _objectSpread({}, DEFAULT_COUNTDOWN_CONFIG, {}, countdownConfig);

  return calculateTimeLeft(config);
}

function getNextTickDelta(_ref, time) {
  var ms = _ref.ms,
      until = _ref.until;
  var timeMod = time % ms;
  var untilMod = until % ms;

  if (timeMod === untilMod) {
    return ms;
  }

  if (timeMod < untilMod) {
    return untilMod - timeMod;
  }

  return untilMod + ms - timeMod;
}

function validateCreateCountdownArgs(callback, countdownConfig) {
  if (!callback) {
    throw new Error("You need to provide a callback as the first argument to createCountdown");
  }

  validateCountdownConfig(countdownConfig);
}

var Countdowns = function Countdowns() {
  var _this = this;

  _classCallCheck(this, Countdowns);

  _defineProperty(this, "countdowns", {});

  _defineProperty(this, "createCountdown", function (callback, countdownConfig) {
    validateCreateCountdownArgs(callback, countdownConfig);
    var id = (0, _id.generateId)();

    var countdownBase = _objectSpread({}, DEFAULT_COUNTDOWN_CONFIG, {}, countdownConfig);

    var newCountdown = _objectSpread({}, countdownBase, {
      callback: callback,
      id: id,
      ms: (0, _getMs.getMs)(countdownBase.interval)
    });

    var now = Date.now();
    var nextTickDelta = getNextTickDelta(newCountdown, now);

    if (newCountdown.until <= now) {
      throw new Error("until property needs to be in the future. Please ensure you are using a millisecond timestamp!");
    }

    newCountdown.timeout = setTimeout(_this.revalidate, nextTickDelta, newCountdown);
    _this.countdowns[id] = newCountdown;
    return function () {
      return _this.removeCountdown(id);
    };
  });

  _defineProperty(this, "stopAllCountdowns", function () {
    Object.keys(_this.countdowns).forEach(function (id) {
      clearTimeout(_this.countdowns[id].timeout);
    });
    _this.countdowns = {};
  });

  _defineProperty(this, "revalidate", function (countdown) {
    clearTimeout(countdown.timeout);
    var timeLeft = calculateTimeLeft(countdown);
    countdown.callback(timeLeft);

    if (timeLeft > 0) {
      var nextTickDelta = getNextTickDelta(countdown, Date.now());
      countdown.timeout = setTimeout(_this.revalidate, nextTickDelta, countdown);
    } else {
      _this.removeCountdown(countdown.id);
    }
  });

  _defineProperty(this, "removeCountdown", function (id) {
    var countdown = _this.countdowns[id];

    if (!countdown) {
      return;
    }

    clearTimeout(countdown.timeout);
    delete _this.countdowns[id];
  });
};

exports.Countdowns = Countdowns;